import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const rows = [['Arriving at training without a plan', 'Everything ready in minutes'], ['Searching for drills online', 'Full 365-day curriculum by module'], ['Skill progression gaps', 'Logical, measurable progression'], ['Player assessment guesswork', 'Performance Testing Guide included'], ['No season structure', 'Full Season Planner included'], ['Weak team culture', 'Culture & Discipline Protocol']];
export function FinalCTA() {
  return <section className="border-y-4 border-[#d4af37] bg-[#0A0A0A] px-5 py-20" data-id="element-36" data-mp="vtq8lqawz4kp">
      <div className="mx-auto max-w-3xl text-center" data-id="element-37" data-mp="qv577njxeeuo">
        <h2 className="font-display text-4xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-38" data-mp="qwgkqf36b0yz">
          Your next training session can keep being improvised.{' '}
          <span className="text-[#d4af37]" data-id="element-39" data-mp="zxo8i382cjet">Or you can have a real system.</span>
        </h2>
        <p className="mx-auto mt-6 max-w-xl font-medium leading-relaxed text-[#B0B0C0]" data-id="element-40" data-mp="2c5pys0lj7m4t">
          Join hundreds of coaches worldwide who already plan their entire
          season in minutes.
        </p>
        <div className="mt-10 overflow-hidden border border-[#d4af37]/30 text-left" data-id="element-41" data-mp="2m1t1p8o7jost">
          <div className="grid grid-cols-2 bg-[#16161F] text-center text-[10px] font-bold uppercase tracking-widest" data-id="element-42" data-mp="2r275ufmouelk">
            <p className="p-4 text-[#B0B0C0]" data-id="element-43" data-mp="2v2r5bpuqhuav">Without Rugby Ready</p>
            <p className="border-l border-[#d4af37]/30 p-4 text-[#d4af37]" data-id="element-44" data-mp="3023nvyekof7n">
              With Rugby Ready
            </p>
          </div>
          {rows.map(([without, withSystem]) => <div key={without} className="grid grid-cols-2 border-t border-[#d4af37]/20 text-xs sm:text-sm" data-id="element-45" data-mp="39s5eawuee9pq">
              <p className="flex gap-2 p-4 font-medium text-[#B0B0C0]" data-id="element-46" data-mp="3et2skycaejly">
                <span className="text-red-400" data-id="element-47" data-mp="3iu4y1wwsrrwd">×</span>
                {without}
              </p>
              <p className="flex gap-2 border-l border-[#d4af37]/20 bg-[#d4af37]/5 p-4 font-semibold text-white" data-id="element-48" data-mp="1jpelxizwhgvo">
                <CheckCircle2Icon className="h-4 w-4 shrink-0 text-[#d4af37]" data-id="element-49" data-mp="1eqjqnhkqxzuo" />
                {withSystem}
              </p>
            </div>)}
        </div>
        <div className="my-9" data-id="element-50" data-mp="1npeysz7cpk0m">
          <CountdownTimer dark data-id="element-51" data-mp="1np5arh5v9mxk" />
        </div>
        <div className="border-2 border-[#d4af37] bg-[#16161F] p-7 text-left" data-id="element-52" data-mp="22eun88jetdd5">
          <p className="text-xs font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-53" data-mp="22gxmzkad6kv2">
            Complete package
          </p>
          <h3 className="mt-2 text-xl font-bold text-white" data-id="element-54" data-mp="2bf9ahdfxp2ja">
            RUGBY READY™ — 6-in-1 Box Set + 5 Strategic Bonuses
          </h3>
          <div className="mt-5 flex items-end justify-between" data-id="element-55" data-mp="27f8wtv0nsvda">
            <div data-id="element-56" data-mp="h0ykv2rim4cg">
              <p className="text-sm font-bold text-[#B0B0C0] line-through" data-id="element-57" data-mp="h2jhcxxe3xcy">
                $97
              </p>
              <p className="font-display text-6xl font-bold leading-none text-white" data-id="element-58" data-mp="d17x77xac4c5">
                $27
              </p>
            </div>
            <p className="bg-[#d4af37] px-3 py-2 text-xs font-bold uppercase" data-id="element-59" data-mp="6xjvnm7jbibh">
              Save $70
            </p>
          </div>
        </div>
        <a href="https://italiano-ready.impultienda.ar/checkout" className="cta-button mt-8 block w-full rounded-2xl px-5 py-5 text-lg font-bold sm:text-xl" data-id="element-60" data-mp="3pahrpi17hr0d">
          GET RUGBY READY NOW
        </a>
        <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0]" data-id="element-61" data-mp="3fc1x352yzzm4">
          <span className="flex gap-1" data-id="element-62" data-mp="3ka3g5q0ebyxl">
            <LockKeyholeIcon className="h-4 w-4 text-[#d4af37]" data-id="element-63" data-mp="36dgj7n8g18ro" />
            Secure payment
          </span>
          <span className="flex gap-1" data-id="element-64" data-mp="3bct1rvsa7tog">
            <ZapIcon className="h-4 w-4 text-[#d4af37]" data-id="element-65" data-mp="3bdvvebgzoa82" />
            Instant access
          </span>
          <span className="flex gap-1" data-id="element-66" data-mp="14j8xrhql207h">
            <ShieldCheckIcon className="h-4 w-4 text-[#d4af37]" data-id="element-67" data-mp="19kogh35afump" />
            7-day guarantee
          </span>
        </div>
      </div>
    </section>;
}